// extracted by mini-css-extract-plugin
export default {"chip":"DifficultyLevel_chip__A0rdp","chip__0":"DifficultyLevel_chip__0__MkecO","chip__1":"DifficultyLevel_chip__1__K4o+J","chip__2":"DifficultyLevel_chip__2__IGq3m"};